import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetRewardProfileRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetRewardProfileResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getRewardProfile = (request: GetRewardProfileRequest, options?: CashRequestOptions) =>
  post<GetRewardProfileRequest, GetRewardProfileResponse>('/2.0/cash/get-reward-profile', request, {
    ...options,
    rejectOnError: true,
  })
